import { SOGetProcess } from '../process/so-get-process';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetDeficiency implements QueryProtocol {

  constructor(
    public uid: string = null,
    public name: string = null,
    public active: boolean = null,
    public process: SOGetProcess = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetDeficiency(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'active' in params ? params.active : null,
      'process' in params ? params.process : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
